/*
 * Copyright (C) 2026 - Potentially Ltd
 *
 * Please see distribution for license.
 */

import { Inject, Injectable } from '@angular/core';
import { SHARED_CARD_DATA_SERVICE, SharedCardDataService } from './card-data.service';

export interface WebLinkCard {
  _id: string;
  webLinkUrl?: string;
}

export function isWebLinkCard(card: { type?: string; v3CardType?: string }): boolean {
  return card.type === 'WEBLINK' || card.v3CardType === 'WEBLINK';
}

/** Links back into the app stay in this tab; anything else opens beside it. */
export function webLinkTarget(url: string, hostname: string = window.location.hostname): '_self' | '_blank' {
  return url.includes(hostname) ? '_self' : '_blank';
}

/**
 * A web link card is not a page: opening it records the open and sends the learner to the link,
 * the way the v2 playlist view does.
 */
@Injectable({ providedIn: 'root' })
export class WebLinkCardService {
  constructor(@Inject(SHARED_CARD_DATA_SERVICE) private readonly cardService: SharedCardDataService) {}

  open(card: WebLinkCard): void {
    if (!card.webLinkUrl) {
      return;
    }
    this.cardService.registerCardOpen(card._id).subscribe();
    window.open(card.webLinkUrl, webLinkTarget(card.webLinkUrl), 'noopener,noreferrer');
  }

  /** For the sidebar and pagination, which only know the card's uri. */
  openByUri(cardUri: string): void {
    this.cardService.getCardDetails(cardUri).subscribe(({ isSuccess, value }) => {
      if (isSuccess && value?.card) {
        this.open(value.card);
      }
    });
  }
}
